import React from "react";
import { Box, Link, Typography } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import "../views/general.css";
import QRCode from "Assets/Images/GUSQRCode.jpg";
import { authService } from "services/authService";
import { browsersLanugage } from "helpers/localization";
import { useTranslation } from "react-i18next";

const QRDetailsTable = () => {

    const { t } = useTranslation();
    const isUserAuthenticated = authService.isAuthenticated();
    const languageCode = isUserAuthenticated ? authService.getUserLocale() : browsersLanugage();
    const qrLink = "https://d36ver3o3fxb7y.cloudfront.net/gus.html?chat-source=field";

    return (
        <div>
            <TableContainer id="conttactGUSTable" aria-label="table field support">
                <table style={{ width: "auto", tableLayout: "auto" }}>
                    <TableBody style={{ width: "100%" }}>
                        <tr>
                            <td width="10%"
                                style={{
                                    padding: 0,
                                    borderBottom: "none",
                                    fontWeight: "bold",
                                    border: "0px solid green",
                                }}
                                align="left">
                                <img
                                    style={{
                                        display: "block",
                                        maxWidth: "80%",
                                        maxHeight: "20%",
                                        marginBottom: "10px",
                                        paddingLeft: "5px"
                                    }}
                                    alt="QR Code"
                                    id={"QRCodeImage"}
                                    src={QRCode}
                                />
                            </td>
                            <td
                                width="20%"
                                style={{
                                    padding: 0,
                                    borderBottom: "none",
                                    border: "0px solid green",
                                }}
                                align="left">

                                <Link
                                    href={qrLink}
                                    className="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-caption MuiTypography-colorInherit"
                                    id="contactUsLink"
                                    color="inherit"
                                    variant="caption"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecorationLine: "underline", color: "blue" }}>
                                    <Typography variant="caption">
                                        {t("ContactUs.ContactUsQRText")}
                                    </Typography>
                                    <Box component="span" className="visuallyHidden">
                                        <Typography variant="caption">
                                            {!languageCode
                                                ? ",opens new window"
                                                : t("Footer.OpenNewWindow")}
                                        </Typography>
                                    </Box>
                                </Link>
                                <div>({t("ContactUs.ContactUsOnlyEuropeText")}) </div>
                            </td>
                        </tr>
                    </TableBody>
                </table>
            </TableContainer>
        </div>
    );
};

export default QRDetailsTable;